import { Record, OrderedMap } from 'immutable';
const Lists = Record({
  count: 0,
  error: undefined,
  hasMore: false,
  isRequesting: false,
  lastLoaded: null,
  lists: OrderedMap(),
  offset: 0
});
export default Lists;